import { render } from "./WelcomeBanner.vue?vue&type=template&id=0c8a3eda&scoped=true"
import script from "./WelcomeBanner.vue?vue&type=script&lang=js"
export * from "./WelcomeBanner.vue?vue&type=script&lang=js"

import "./WelcomeBanner.vue?vue&type=style&index=0&id=0c8a3eda&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c8a3eda"

export default script